var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAlert = function SvgIconAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.981 74.4272L63.5964 13.5967C57.8168 3.54775 43.2014 3.54775 37.4426 13.5967L2.03727 74.4272C-3.74235 84.4761 3.45099 96.96 15.1142 96.96H85.7793C97.4425 96.96 104.761 84.3523 98.981 74.4272Z",
    fill: "#EC4B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4984 72.2815C53.5753 72.2815 56.1325 74.8195 56.0077 78.0179C56.1532 80.9273 53.4505 83.4654 50.4984 83.4654C47.4214 83.4654 44.8643 80.9273 44.8643 77.8734C44.8643 74.8195 47.4214 72.2815 50.4984 72.2815ZM55.6335 36.0886C56.0285 36.9759 56.1532 37.8632 56.1532 38.8949C56.0285 41.7218 55.7582 44.5281 55.6335 47.3138L54.8643 60.2929C54.7395 61.696 54.7395 62.9753 54.7395 64.3578C54.6148 66.6483 52.8061 68.4228 50.4984 68.4228C48.1907 68.4228 46.4027 66.7721 46.2572 64.4817C45.883 57.7342 45.488 51.1105 45.1138 44.363C44.989 42.5885 44.8643 40.7933 44.7188 39.0187C44.7188 36.0886 46.3819 33.6744 49.0846 32.9109C51.7873 32.2712 54.4693 33.5506 55.6335 36.0886Z",
    fill: "#FAFAFA",
    opacity: 0.1
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_alert.34cf720b.svg";
export { ForwardRef as ReactComponent };